import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ThirdPartyTableWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S12};
  width: 100%;
  min-height: 0;
`
